import React, { useEffect, useState } from 'react';
import PatientSearchForFileUpload from './patientSearch';
import PatientFiles from '../../components/prescription/patient-files/patientFiles';

export const Files = () => {
    const [selectedTabOption, setSelectedTabOption] = useState(1);
    const [, setIsNewUser] = useState(true);
    const [singlePatientInfo, setSinglePatientInfo] = useState({});
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const userAgent = navigator.userAgent;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        setIsMobile(mobileRegex.test(userAgent));
    }, []);

    return (
        <section
            className={`${!isMobile ? 'content-wrapper main-content home-section mt-0 pt-0' : ''} `}
            style={{ marginLeft: !isMobile ? '69px' : '0px', height: '100vh' }}
        >
            {!singlePatientInfo?._id && (
                <PatientSearchForFileUpload
                    setSelectedTabOption={setSelectedTabOption}
                    setIsNewUser={setIsNewUser}
                    setSinglePatientInfo={setSinglePatientInfo}
                    singlePatientInfo={singlePatientInfo}
                    selectedTabOption={selectedTabOption}
                    height={37}
                />
            )}
            {singlePatientInfo?._id && (
                <div className="files-page__patient-files mx-3">
                    <p
                        className="d-inline px-3 mb-2"
                        style={{
                            color: 'white',
                            backgroundColor: '#12AB81',
                            fontSize: '13px',
                            borderRadius: '2px',
                            cursor: 'pointer',
                        }}
                        onClick={() => setSinglePatientInfo({})}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                setSinglePatientInfo({});
                            }
                        }}
                    >
                        Back
                    </p>
                    <PatientFiles
                        visitDetails={{ patient: singlePatientInfo._id }}
                        patientDetails={singlePatientInfo}
                        canUpload
                        requireVisit={false}
                    />
                </div>
            )}
        </section>
    );
};
